module.exports = __webpack_public_path__ + "static/media/header-cover.613fbbbe.webp";